/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { Loader } from 'modules/common/components';
import useQuery from 'modules/common/hooks/use-query';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectLoader } from 'modules/verify-callback/selectors';
import { selectNotification } from 'modules/common/notifications/selectors';
import { Button, Grid } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import ROUTES from 'modules/common/constants/route';
import { verifyCallbackActions } from 'modules/verify-callback/slice';
import { selectResetPasswordToken } from 'modules/common/auth/selectors';
import useAuthErrors from 'modules/common/hooks/use-error-message';
import { notificationActions } from 'modules/common/notifications/slice';
import { Alert, Root } from './style';
/**
 * Centralized component for capturing all the call back endpoints
 * @returns
 */
const VerifyCallback = () => {
  const { generateError, message } = useAuthErrors();
  //
  const dispatch = useDispatch();
  const navigate = useNavigate();
  //
  const loading = useSelector(selectLoader);
  const notification = useSelector(selectNotification);
  const incomingToken = useSelector(selectResetPasswordToken);
  //
  const query = useQuery();
  const token = query.get('token');
  const tokenType = query.get('type');
  const email = query.get('email');
  //
  useEffect(() => {
    if (token) {
      dispatch(verifyCallbackActions.verifyToken({ token }));
    }
  }, [token]);
  //
  useEffect(() => {
    if (notification?.isEnabled) {
      generateError(notification);
    }
    return () => notification?.isEnabled && dispatch(notificationActions.resetNotification());
  }, [notification]);
  //
  useEffect(() => {
    if (incomingToken) {
      if (tokenType === 'resetPassword') {
        navigate(ROUTES.RESET_PASSWORD);
      }
      if (tokenType === 'userInvitation') {
        navigate(ROUTES.SIGN_UP);
      }
    }
  }, [incomingToken]);
  useEffect(() => {
    if (email) {
      dispatch(verifyCallbackActions.setEmailId(email));
    } else {
      dispatch(verifyCallbackActions.setEmailId(''));
    }
  }, [email]);
  //
  return (
    <Root>
      <Loader loading={loading}>
        {notification?.isEnabled && (
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            paddingTop={20}
            direction="column"
          >
            <Grid item xs={12}>
              😢 😢 😢
            </Grid>
            <Grid item xs={12}>
              <Alert mt={2} mb={3} severity={notification?.type}>
                {message}
              </Alert>
            </Grid>
          </Grid>
        )}

        {incomingToken && tokenType === 'resetPassword' && (
          <Button component={Link} to={ROUTES.FORGOT_PASSWORD} fullWidth color="primary">
            Go Back
          </Button>
        )}
      </Loader>
    </Root>
  );
};
//
export default VerifyCallback;
